import { render, staticRenderFns } from "./NsFooter.vue?vue&type=template&id=338c886d&scoped=true"
import script from "./NsFooter.vue?vue&type=script&lang=js"
export * from "./NsFooter.vue?vue&type=script&lang=js"
import style0 from "./NsFooter.vue?vue&type=style&index=0&id=338c886d&prod&scoped=true&lang=css"
import style1 from "./NsFooter.vue?vue&type=style&index=1&id=338c886d&prod&scoped=true&lang=scss"
import style2 from "./NsFooter.vue?vue&type=style&index=2&id=338c886d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c886d",
  null
  
)

export default component.exports